import { defaultTo, path, pipe } from 'ramda';
import { isLinkInSmsSupported } from './helpers';
import { getActiveShop } from '../../auth/selectors';
import {
  getStoredReaderIntentCaptureResult,
  getTotalFromReaderIntentCaptureResult,
} from '../../register/webReader/selector';

export const getLoading = path(['receipts', 'loading']);
export const getError = path(['receipts', 'error']);
export const getTotal = pipe(
  path(['receipts', 'receiptData', 'total']),
  defaultTo(0)
);
export const getPhone = path(['receipts', 'receiptData', 'phone']);
export const getEmail = path(['receipts', 'receiptData', 'email']);
export const getHasAppointment = path(['receipts', 'receiptData', 'hasAppointment']);

export const getIsLinkInSmsSupported = pipe(getActiveShop, isLinkInSmsSupported);

// when tipping on reader, only capture endpoint's response contains correct totals and tips
// so we check if it's present and if so, show total from there
export const getTotalForReceipt = (state) => {
  const hasTerminalCaptureResult = getStoredReaderIntentCaptureResult(state);
  return hasTerminalCaptureResult ? getTotalFromReaderIntentCaptureResult(state) : getTotal(state);
};
